import React from 'react';
import { gradeGroups, packItems } from '../data/content';
import { icons } from '../utils/icons';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
export function WhatsInside() {
  return <section id="inside" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-254" data-mp="kvg53wgpo0yr">
      <div className="mx-auto max-w-6xl" data-id="element-255" data-mp="put0x6pk8idh">
        <SectionHeading eyebrow="Dentro del kit" title={<>
              ¿Qué hay dentro del{' '}
              <span className="text-brand" data-id="element-257" data-mp="b552qecodztz">Kit Educación Física Lista™</span>?
            </>} subtitle="Seis bloques de material que cubren el año escolar completo, desde la explicación en el patio hasta el informe final." data-id="element-256" data-mp="pthoyjlyo4ba" />

        <Reveal delay={0.05} data-id="element-258" data-mp="23x6s2xmtb32">
          <div className="mt-12 overflow-hidden rounded-2xl border-2 border-ink bg-bone" data-id="element-259" data-mp="741mvrumo3sr">
            <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-1 border-b-2 border-ink px-5 py-3" data-id="element-260" data-mp="3ocg8wl3kxpgp">
              <span className="text-xs font-extrabold uppercase tracking-[0.16em] text-ink/60" data-id="element-261" data-mp="3tazvmnpzz5a4">
                Un volumen por grado
              </span>
              <span className="text-xs font-extrabold uppercase tracking-[0.16em] text-brand" data-id="element-262" data-mp="37utdqdk9qtfu">
                12 volúmenes incluidos
              </span>
            </div>

            <div className="grid gap-5 p-5 sm:grid-cols-2 sm:gap-6 sm:p-6" data-id="element-263" data-mp="3ltsz9cchis7s">
              {gradeGroups.map(group => <div key={group.level} data-id="element-264" data-mp="3hr61yvx1of37">
                  <p className="font-display text-sm tracking-[0.12em] text-ink/55" data-id="element-265" data-mp="2u4hja807oilj">
                    {group.level}
                  </p>
                  <ul className="mt-3 grid grid-cols-6 gap-2" data-id="element-266" data-mp="2p28nl3vyf2fq">
                    {group.grades.map(grade => <li key={`${group.level}-${grade}`} className={`flex h-14 flex-col items-center justify-center rounded-lg font-display text-base leading-none ${group.level === 'Primaria' ? 'bg-ink text-volt' : 'bg-brand text-white'}`} data-id="element-267" data-mp="32xkppwcfvv6o">
                        {grade}
                        <span className="mt-1 text-[9px] font-sans font-bold uppercase tracking-[0.1em] opacity-70" data-id="element-268" data-mp="eaznld3i9r0n">
                          {group.level.slice(0, 4)}
                        </span>
                      </li>)}
                  </ul>
                </div>)}
            </div>
          </div>
        </Reveal>

        <ul className="mt-6 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-269" data-mp="3riklbbv3rvv6">
          {packItems.map((item, index) => {
          const Icon = icons[item.icon];
          return <Reveal key={item.title} delay={index * 0.04} className="h-full" data-id="element-270" data-mp="b83qvqb5geq" data-mpi={index}>
                <li className="flex h-full flex-col rounded-2xl border-2 border-ink bg-white p-7 transition-transform duration-200 ease-out hover:-translate-y-1" data-id="element-271" data-mp="5cdwgtjyx3o9">
                  <div className="flex items-center justify-between" data-id="element-272" data-mp="1gq9nazk8j0vb">
                    <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-ink text-volt" data-id="element-273" data-mp="1gsm4vbm2z97u">
                      <Icon className="h-6 w-6" aria-hidden="true" data-id="element-274" data-mp="2w9z5gqinm37i" />
                    </span>
                    <span className="font-display text-2xl text-ink/10" data-id="element-275" data-mp="2rj0jbaaziawc">
                      {String(index + 1).padStart(2, '0')}
                    </span>
                  </div>
                  <h3 className="mt-6 font-display text-xl leading-tight text-ink" data-id="element-276" data-mp="2mi35f9x0c30n">
                    {item.title}
                  </h3>
                  <p className="mt-3 text-base leading-relaxed text-ink/70" data-id="element-277" data-mp="2dizl62m3thkk">
                    {item.text}
                  </p>
                </li>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}